"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceNavComponent = void 0;
require("./slice-nav.scss");
var lodash_1 = require("lodash");
var Component_1 = require("../Component");
var util_1 = require("../util");
var SliceNavComponent = /** @class */ (function (_super) {
    __extends(SliceNavComponent, _super);
    function SliceNavComponent(element, groupCount) {
        var _this = _super.call(this, element) || this;
        _this.groupCount = groupCount;
        if (groupCount <= 1)
            throw new Error('Unexpected groupCount: ' + groupCount);
        return _this;
    }
    Object.defineProperty(SliceNavComponent.prototype, "data", {
        set: function (data) {
            this._data = data;
            this.renderPages(data);
        },
        enumerable: false,
        configurable: true
    });
    SliceNavComponent.prototype.onInit = function () {
        this.$element.addClass('wk-slice-nav').append(util_1.$element('nav').append(util_1.$element('ul')));
    };
    SliceNavComponent.prototype.onDestroy = function () { };
    SliceNavComponent.prototype.renderPages = function (data) {
        var _this = this;
        var ul = this.$element.findFirst('nav > ul');
        if (!ul)
            return;
        var $ul = util_1.$helper(ul).empty();
        if (data) {
            var groupCount = this.groupCount;
            var limit = data.limit;
            var totalPages = Math.ceil(data.total_items / limit);
            var currPage = Math.ceil(data.offset / limit) + 1;
            var currGroup = Math.ceil(currPage / groupCount);
            var startPage = (currGroup - 1) * groupCount + 1;
            var endPage = Math.min(currGroup * groupCount, totalPages) + 1;
            // endPage는 현재 페이지그룹에 포함되지 않음
            var pageList = lodash_1.range(startPage, endPage);
            this.pageList = pageList;
            this.currPage = currPage;
            this.prevPage = startPage > 1 ? startPage - 1 : undefined;
            this.nextPage = endPage <= totalPages ? endPage : undefined;
            var $pageItem = function (page, content) {
                return util_1.$element('li', 'page-item')
                    .append(util_1.$element('a', 'page-link', { tabindex: '0' }).append(content))
                    .on('click', function () { return _this.onClickPageNumber(page); });
            };
            if (this.prevPage)
                $ul.append($pageItem(this.prevPage, '<'));
            for (var _i = 0, _a = this.pageList; _i < _a.length; _i++) {
                var page = _a[_i];
                if (page === currPage) {
                    $ul.append(util_1.$element('li', 'page-item active').append(util_1.$element('a', 'page-link').setText(page)));
                }
                else {
                    $ul.append($pageItem(page, page.toString()));
                }
            }
            if (this.nextPage)
                $ul.append($pageItem(this.nextPage, '>'));
        }
    };
    SliceNavComponent.prototype.onClickPageNumber = function (pageNumber) {
        if (pageNumber !== this.currPage) {
            var data = this._data;
            if (data) {
                this.element.dispatchEvent(new CustomEvent('page-click', {
                    detail: {
                        request: lodash_1.defaults({
                            limit: data.limit,
                            offset: data.limit * (pageNumber - 1),
                            total_items: data.total_items,
                        }, data.request),
                        page: pageNumber,
                    }
                }));
            }
        }
    };
    SliceNavComponent.prototype.addEventListener = function (type, listener) {
        this.element.addEventListener(type, listener);
    };
    return SliceNavComponent;
}(Component_1.Component));
exports.SliceNavComponent = SliceNavComponent;
